<template>
  <div class="home">
    <!-- 轮播图 -->
    <div v-scroll:throttle="{fn: onScroll, throttle: 500 }" style="overflow: auto;height:100%;">
      <!-- 弹框 -->
      <el-dialog :visible.sync="dialogVisible" width="30%">
        <div>
          <div class="dialog_title">分享到朋友圈</div>
          <div class="dialog_img">
            <img src="../assets/erweima.png" alt />
          </div>
          <div class="dialog_title2">打开微信扫一扫</div>
          <div class="dialog_title1">即可关注升学地图</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 头部 -->
      <div class="header bg_activite">
        <div class="header_list">
          <img src="../assets/logo.png" alt />
        </div>
        <div>
          <el-dropdown @command="handleCommand">
            <img src="../assets/logo_right.png" alt />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">升学地图</el-dropdown-item>
              <el-dropdown-item command="b">更多产品</el-dropdown-item>
              <el-dropdown-item command="c">热点资讯</el-dropdown-item>
              <el-dropdown-item command="d">关于我们</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="context">
      <div v-html="details.Content"></div>
    </div>
    <!-- 底部 -->
    <div class="fotter" id="fotter">
        <div class="fotter_erweima">
          <img src="../assets/erweima.png" alt />
          <p class="fotter_erweima_phone">微信公众号</p>
          <p class="fotter_erweima_phone1">客服热线：021-8031-3322</p>
        </div>
        <div class="fotter_right">
          <div class="fotter_right_chanpin">
            <h2 class="fotter_right_title">更多产品</h2>
            <ul class="fotter_right_ul" style="margin-left:10px;">
              <li>壹志愿</li>
              <li>壹培优</li>
              <li>蘑菇岛</li>
              <li>蘑菇家长</li>
            </ul>
          </div>
          <div class="fotter_right_chanpin">
            <h2 class="fotter_right_title">关于我们</h2>
            <ul class="fotter_right_ul">
              <li>
                <img src="../assets/web.png" alt />
                <a href="https://www.yrtsedu.cn/">https://www.yrtsedu.cn/</a>
              </li>
              <li>
                <img src="../assets/web.png" alt />
                上海市金沙江路1628弄1号楼·11F
              </li>
            </ul>
          </div>
        </div>
        <div class="fotter_bottom">©2020 上海跃然图上教育科技有限公司 沪ICP备20018345号</div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  data() {
    return {
      dialogVisible: false,
      Scroll: 0,
      position: { scrollTop: 0, scrollLeft: 0 },
      isShow: false,
      isStatus: false,
      isActivite: false,
      PageIndex: 1,
      PageSize: 10,
      details: {},
    };
  },
  created() {
    if (this.$route.params.id == undefined) {
      this.$router.go(-1); //返回上一层
    } else {
      this.__init();
    }
  },
  methods: {
    __init() {
      this.axios
        .get(
          "http://39.106.227.197:8000/api/WebSite_FurtherEducation_News/GetNewsDetail",
          {
            params: {
              Id: this.$route.params.id,
            },
          }
        )
        .then((res) => {
          // console.log(res.data.response, "---");
          this.details = res.data.response;
        });
    },
    // 描点定位
    onReturnTop() {
      document.querySelector("#countainer").scrollIntoView({
        behavior: "smooth", // 平滑过渡
      });
    },
    handleCommand(command) {
      switch (command) {
        case "d":
          document.querySelector("#fotter").scrollIntoView({
            behavior: "smooth", // 平滑过渡
          });
          break;
        case "c":
          document.querySelector("#news").scrollIntoView({
            behavior: "smooth", // 平滑过渡
          });
          break;
        case "a":
          this.$router.go(-1);
          break;
      }
    },
    onImg() {
      this.dialogVisible = true;
    },
    onScroll(e, position) {
      console.log(e, position);
      this.position = position;
    },
  },
};
</script>
<style lang="less" scoped>
.context {
  max-width: 1200px;
  height: 100%;
  min-height: 300px;
  margin: 0 auto;
  // text-align: center;
  margin-top: 126px;
  line-height: 30px;
}
.bg_activite {
  background: #5ea1fb;
  transition: all 0.3s;
}
.fotter {
  width: 100%;
  height: 480px;
  background: url("../assets/fotter.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  margin-top: 60px;
  .fotter_bottom {
    position: absolute;
    bottom: 25px;
    left: 0;
    right: 0;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }
  .fotter_erweima {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 50%;
    // border: 1px solid red;
    .fotter_erweima_phone {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #ffffff;
      padding-top: 25px;
    }
    .fotter_erweima_phone1 {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #ffffff;
      padding-top: 12px;
    }
  }
  .fotter_right {
    width: 50%;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    justify-content: center;
    .fotter_right_chanpin {
      // width: 300px;
      // text-align: center;
      // border: 1px solid red;
      height: 300px;
      margin: 0 auto;
      .fotter_right_title {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 600;

        color: #ffffff;
      }
      .fotter_right_ul {
        li {
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          padding: 10px 0 20px 0;
          a {
            color: #ffffff;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
.countainer {
  width: 100%;
  .news {
    min-width: 1200px;
    padding-top: 100px;
    // height: 400px;
    .countainer_box_title {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5da1fb;
      text-align: center;
      padding-top: 90px;
    }
    .news_box1 {
      display: flex;
      align-items: center;
      justify-content: center;
      .news_detail {
        width: 510px;
        height: 610px;
        margin: 10px;
        // border: 1px solid red;
        position: relative;
        background: #ffffff;
        box-shadow: 1px 8px 14px 0px rgba(94, 162, 251, 0.1);
        border-radius: 10px;
        .news_detail_f1 {
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #343434;
          padding: 20px;
        }
        .news_detail_f1_box {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: space-around;
          padding: 10px;
          .news_detail_index {
            width: 15px;
            height: 15px;
            background: red;
            color: #fff;
            text-align: center;
            line-height: 15px;
          }
          .news_detail_count {
            // width: 342px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #343434;
          }
        }
        .news_detail_title {
          font-size: 28rpx;
          font-family: PingFang SC;
          font-weight: 600;
          color: #343434;
          text-align: center;
          padding-top: 75px;
        }
        .news_detail_ul {
          display: flex;
          justify-content: center;
          /* margin: 0 auto; */
          align-items: center;
          flex-wrap: wrap;
          text-align: center;
          li {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #343434;
            padding-top: 15px;
          }
          ul li {
            list-style: none;
          }
        }
      }
    }
  }
  .countainer_box {
    min-width: 1200px;
    // height: 400px;
    // border: 1px solid red;

    .countainer_box_title {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5da1fb;
      text-align: center;
      padding-top: 90px;
    }
    .countainer_box_desc {
      width: 802px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #5ea2fb;
      line-height: 24px;
      text-align: center;
      margin: 0 auto;
      padding-top: 30px;
    }
  }
  .countainer_box_img {
    display: flex;
    align-items: center;
    justify-content: center;
    .count_img {
      width: 385px;
      height: 405px;
      // border: 1px solid red;
      margin: 10px;
      position: relative;
      .count_activite {
        position: absolute;
        top: 0;
        background: #333;
        opacity: 0.8;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transition: all 0.3s;
        p {
          color: #fff;
          font-size: 20px;
          font-weight: 500;
          margin-top: 10px;
        }
      }
      .count_img_title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #343434;
        padding: 20px;
      }
      .count_img_desc {
        padding-left: 20px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #343434;
        span {
          color: #fe4141;
        }
      }
    }
  }
}
.dialog_img {
  text-align: center;
  img {
    width: 254px;
    height: 251px;
  }
}
.dialog_title {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #5ea2fb;
  text-align: center;
  padding: 20px;
}
.dialog_title1 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #5ea2fb;
  text-align: center;
}
.dialog_title2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #5ea2fb;
  text-align: center;
}
.block {
  position: relative;
  .wx_position {
    position: absolute;
    left: 363px;
    bottom: 87px;
    z-index: 99;
    img {
      width: 51px;
      height: 41px;
    }
  }
  .search_position {
    position: absolute;
    bottom: 98px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 140px;
    height: 50px;
    border: 2px solid #ffffff;
    opacity: 0.7;
    border-radius: 10px;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    span {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 126px;
  // background: #5ea1fb;
  // opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 99;
}
.banner_img {
  width: 100%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>